
import { defineComponent, ref } from "vue";
import AuthenticatorHeader from "./AuthenticatorHeader.vue";
import PasswordRequirements from "./PasswordRequirements.vue";
import { useGammaAuthenticator } from "@/composeable/gamma-authenticator";
import { AuthUIState } from "@/types/auth-ui";
import { focusRequiredEmptyInput } from "@/util/auth-ui";

export default defineComponent({
  components: { AuthenticatorHeader, PasswordRequirements },
  setup() {
    const { resendCode, confirmResetPassword } = useGammaAuthenticator();
    const code = ref<string>();
    const password = ref("");
    const confirmPassword = ref("");
    const isValid = ref(false);
    const errorMessage = ref<string | undefined>(undefined);
    const showResendSuccess = ref(false);
    const loading = ref(false);

    const codeRef = ref();
    const passwordRef = ref();
    const confirmPasswordRef = ref();

    async function resetPassword() {
      focusRequiredEmptyInput([
        codeRef.value.$el,
        passwordRef.value.$el,
        confirmPasswordRef.value.$el,
      ]);

      if (!isValid.value) return;

      if (
        !(
          code.value &&
          password.value &&
          confirmPassword.value &&
          password.value === confirmPassword.value
        )
      ) {
        return;
      }

      loading.value = true;
      try {
        await confirmResetPassword(code.value, password.value);
      } catch (error) {
        errorMessage.value = error.message;
      }
      loading.value = false;
    }

    async function resendNewCode() {
      await resendCode();
      showResendSuccess.value = true;
    }

    return {
      AuthUIState,
      code,
      password,
      confirmPassword,
      errorMessage,
      loading,
      codeRef,
      passwordRef,
      confirmPasswordRef,
      showResendSuccess,
      isValid,
      resetPassword,
      resendNewCode,
    };
  },
});
